import { carouselData } from '@/mocks/home';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=Summer%20entertainment%20event%20collage%20abstract%20editorial%20art%2C%20warm%20coral%20and%20golden%20palette%2C%20modern%20minimal%20magazine%20cover%20style%2C%20soft%20gradients%20with%20clean%20geometric%20shapes%2C%20high%20detail%20digital%20illustration&width=1000&height=560&seq=crsl-1-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Internet%20slang%20and%20social%20media%20lexicon%20abstract%20typography%20art%2C%20warm%20amber%20and%20rose%20gold%20color%20scheme%2C%20modern%20editorial%20design%2C%20clean%20minimal%20composition%2C%20high%20detail&width=1000&height=560&seq=crsl-2-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Data%20flow%20and%20network%20propagation%20abstract%20art%2C%20warm%20terracotta%20and%20soft%20neutral%20tones%2C%20modern%20editorial%20magazine%20style%2C%20minimal%20design%20with%20flowing%20organic%20shapes%2C%20high%20detail&width=1000&height=560&seq=crsl-3-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Economics%20and%20business%20intersection%20with%20entertainment%20abstract%20art%2C%20warm%20coral%20and%20golden%20amber%20gradients%2C%20modern%20editorial%20design%2C%20clean%20geometric%20composition%2C%20high%20detail&width=1000&height=560&seq=crsl-4-51cg&orientation=landscape',
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">深度策划，一网打尽吃瓜精华</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselData.map((item, i) => (
            <div
              key={i}
              className="relative group rounded-xl overflow-hidden cursor-pointer"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden">
                <img
                  src={carouselImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
              </div>

              {/* Overlay content */}
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className={`inline-block px-2.5 py-1 text-background-50 text-[10px] font-bold rounded bg-gradient-to-r ${item.color} mb-3 whitespace-nowrap`}>
                  {item.label}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-background-200 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}